module.exports = __webpack_public_path__ + "/images/ico-nav-config.2b06907.svg";